export const DashboardLabelText = {
  SUCCESS_TOAST_MESSAGE: 'Invites resent',
  CONFIRM_MODAL: {
    CONFIRM_BUTTON: 'Resend',
    CANCEL_BUTTON: 'Cancel',
    TITLE: 'Resend invites?',
    SUBTITLE: 'They can only be sent once every 24 hours'
  },
  ALLOWANCE_CTA: {
    BUTTON: 'Set up an allowance',
    TITLE: 'Set up meal and grocery allowances for your employees',
    INFO: 'Expense allowances easily'
  },
  PANDAPRO_CTA: {
    BUTTON: 'Join pandapro',
    TITLE: 'Get access to exclusive perks for your team with pandapro',
    INFO: 'The ultimate all-in-one subscription'
  },
  GIFTCARD_CTA: {
    BUTTON: 'Send gift cards',
    TITLE: 'Celebrate work & life milestones with gift cards',
    INFO: 'Perfect for all occasions'
  },
  STATS: {
    PENDING_EMPLOYEES: 'Pending employees',
    PENDING_EMPLOYEES_BUTTON: 'Resend invites',
    ACTIVE_EMPLOYEES: 'Active employees',
    ACTIVE_EMPLOYEES_BUTTON: 'Add employees',
    SUBSCRIBE_EMPLOYEES: 'Active subscribers',
    SUBSCRIBE_EMPLOYEES_BUTTON: 'Subscribe'
  }
};
